import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeSection: null,
  isMobile: window.innerWidth < 768,
  isMenuOpen: false,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setActiveSection: (state, action) => {
      state.activeSection = action.payload;
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
  },
});

export const { setActiveSection, setIsMobile, toggleMenu } = navigationSlice.actions;
export default navigationSlice.reducer; 